import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import { ExecuteOperationOnPipe, ModelWithForm } from '@morningtrain/react-resources'
import { Fieldset } from 'layouts'
import * as UI from 'ui'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import * as Displays from 'support/displays'
import * as Fields from 'support/fields'

export default function ContractTemplateSmartview ({ id = null }) {
  return (
    <ModelWithForm resourceName='employments.contract_templates' id={id}>
      <ExecuteOperationOnPipe namespace='api' resourceName='employments.contract_templates' operationName='index' />
      <MountSmartviewOnPipe
        smartview={payload => <ContractTemplateSmartview id={payload.response.model.id} />}
        replace={false}
      />

      <Translator namespace='hr.contracts'>
        <Smartview
          header={id !== null
            ? (
              <Displays.Text name='name' />
              )
            : (
              <Translation name='titles.template' />
              )}
          footer={(
            <UI.ButtonWrap>
              <UI.SubmitButton>
                <Translation name='generic.save' />
              </UI.SubmitButton>
            </UI.ButtonWrap>
        )}
        >
          <SmartviewContentSection>
            <Fieldset>
              <Fields.Input
                name='name'
                label={<Translation name='fields.name.label' />}
              />
              <Fields.Select
                name='slug'
                enum='contract_slug'
                placeholder='-'
                label={<Translation name='fields.contract_slug.label' />}
              />
              <Fields.ResourceSelector
                name='employment_type_id'
                optionsKey='name'
                resourceName='employments.employment_type'
                placeholder='-'
                label={<Translation name='fields.employment_type.label' />}
              />
              <Fields.ResourceSelector
                name='department_id'
                optionsKey='name'
                resourceName='departments'
                placeholder='-'
                label={<Translation name='fields.base_department.label' />}
              />
              <Fields.ResourceSelector
                name='webmerge_id'
                optionsKey='name'
                resourceName='employments.contract_templates'
                operationName='webmerge_options'
                placeholder='-'
                label={<Translation name='fields.webmerge_id.label' />}
              />
              <Fields.TabsField
                name='status'
                enum='active_status'
                defaultValue='active'
                label='Status'
              />
              <Fields.TabsField
                name='locale'
                enum='language'
                defaultValue='da'
                label={<Translation name='fields.locale.label' />}
              />
            </Fieldset>
          </SmartviewContentSection>
        </Smartview>
      </Translator>
    </ModelWithForm>
  )
}
